"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isIOS(navigator) {
  if (!navigator) return false;
  if (!navigator.userAgent) return false;
  if (!navigator.userAgent.match) return false;
  return navigator.userAgent.match(/ipad|iphone/i);
}

exports.default = isIOS;